/*
 * Função que recebe um texto e retorna um slug
 * @param text Texto a ser slugificado
 * @returns Slug gerado a partir do texto
 */
export const slugify = (text: string) => {
  return text
    .normalize("NFD") // Remove acentos
    .replace(/[\u0300-\u036f]/g, "") // Remove diacríticos
    .toLowerCase() // Converte para minúsculo
    .replace(/[^a-z0-9]/g, "-") // Substitui espaços e caracteres especiais por hífen
    .replace(/-+/g, "-") // Remove múltiplos hífens consecutivos
    .replace(/^-|-$/g, ""); // Remove hífens no início ou fim
};
